<template>
    <v-dialog
            v-model="errorMsg"
            width="600"
    >
        <v-card class="text-sm-center pa-5">
            <h2>Something went wrong please try again later</h2>
            <v-btn round  class="mt-3" color="primary" @click="$store.dispatch('setErrorMessage',false)">Close</v-btn>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "errorPopup",
        computed: {
            errorMsg() {
                return this.$store.state.core.errorMsg
            }
        }
    }
</script>

<style scoped>

</style>